export const HIDE_SESSION_EXPIRED_DIALOG = 'app/HIDE_SESSION_EXPIRED_DIALOG';
export type AppState = {
    sessionExpiredAcknowledged: boolean;
};

type HideSessionExpiredAction = {
    type: typeof HIDE_SESSION_EXPIRED_DIALOG;
};

export type AppActions = HideSessionExpiredAction;
